// ============================================================
// Teacher Assignments Mock Data
// ============================================================
// References existing classes & sections from mock/classes.js & mock/sections.js

export const mockTeacherAssignments = [
  // ── Rajesh Sharma (teacher-1) — Mathematics ───────────────
  {
    id: 'assign-1',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'Mathematics',
    isClassTeacher: true,
    session: '2024-2025',
  },
  {
    id: 'assign-2',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-2',
    sectionName: 'Section B',
    subject: 'Mathematics',
    isClassTeacher: false,
    session: '2024-2025',
  },
  {
    id: 'assign-3',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-2',
    className: 'Grade 2',
    sectionId: 'sec-3',
    sectionName: 'Section A',
    subject: 'Mathematics',
    isClassTeacher: false,
    session: '2024-2025',
  },
  // ── Priya Patel (teacher-2) — Science ─────────────────────
  {
    id: 'assign-4',
    teacherId: 'teacher-2',
    schoolId: 'school-1',
    classId: 'class-2',
    className: 'Grade 2',
    sectionId: 'sec-3',
    sectionName: 'Section A',
    subject: 'Science',
    isClassTeacher: true,
    session: '2024-2025',
  },
  {
    id: 'assign-5',
    teacherId: 'teacher-2',
    schoolId: 'school-1',
    classId: 'class-2',
    className: 'Grade 2',
    sectionId: 'sec-4',
    sectionName: 'Section B',
    subject: 'Science',
    isClassTeacher: false,
    session: '2024-2025',
  },
  {
    id: 'assign-6',
    teacherId: 'teacher-2',
    schoolId: 'school-1',
    classId: 'class-3',
    className: 'Grade 3',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'Physics',
    isClassTeacher: false,
    session: '2024-2025',
  },
  // ── Amit Kumar (teacher-3) — English ──────────────────────
  {
    id: 'assign-7',
    teacherId: 'teacher-3',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'English',
    isClassTeacher: false,
    session: '2024-2025',
  },
  {
    id: 'assign-8',
    teacherId: 'teacher-3',
    schoolId: 'school-1',
    classId: 'class-3',
    className: 'Grade 3',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'English',
    isClassTeacher: true,
    session: '2024-2025',
  },
  {
    id: 'assign-9',
    teacherId: 'teacher-3',
    schoolId: 'school-1',
    classId: 'class-4',
    className: 'Grade 4',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'English',
    isClassTeacher: false,
    session: '2024-2025',
  },
  // ── Sunita Verma (teacher-4) — Hindi ──────────────────────
  {
    id: 'assign-10',
    teacherId: 'teacher-4',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'Hindi',
    isClassTeacher: false,
    session: '2024-2025',
  },
  {
    id: 'assign-11',
    teacherId: 'teacher-4',
    schoolId: 'school-1',
    classId: 'class-2',
    className: 'Grade 2',
    sectionId: 'sec-4',
    sectionName: 'Section B',
    subject: 'Hindi',
    isClassTeacher: true,
    session: '2024-2025',
  },
  // ── Vikram Singh (teacher-5) — Social Science ─────────────
  {
    id: 'assign-12',
    teacherId: 'teacher-5',
    schoolId: 'school-1',
    classId: 'class-4',
    className: 'Grade 4',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'History',
    isClassTeacher: true,
    session: '2024-2025',
  },
  {
    id: 'assign-13',
    teacherId: 'teacher-5',
    schoolId: 'school-1',
    classId: 'class-5',
    className: 'Grade 5',
    sectionId: 'sec-5',
    sectionName: 'Section A',
    subject: 'Geography',
    isClassTeacher: false,
    session: '2024-2025',
  },
];
